import React, { useCallback, useEffect, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";
import "./TestimonialSection.css";

const TESTIMONIALS = [
  {
    name: "Mark Sorensen",
    title: "Homeowner",
    rating: 5,
    text:
      "Tasker transformed my kitchen with their renovation expertise. Their team was professional and attentive to every detail. Highly recommend!",
    avatar: "https://i.pravatar.cc/120?img=12",
  },
  {
    name: "Mary Smith",
    title: "Home Renovator",
    rating: 5,
    text:
      "Tasker transformed my kitchen beautifully! Their attention to detail and professionalism made the process seamless. Highly recommend!",
    avatar: "https://i.pravatar.cc/120?img=5",
  },

  {
    name: "Alex Neville",
    title: "Property Manager",
    rating: 5,
    text:
      "Tasker transformed my home with their exceptional service. From start to finish, they were professional and attentive to my needs.",
    avatar: "https://i.pravatar.cc/120?img=33",
  },
  {
    name: "Amanda Rojers",
    title: "Account Manager",
    rating: 5,
    text:
      "From quote to final walkthrough, fantastic experience. Clear communication and great craftsmanship. Would hire again.",
    avatar: "https://i.pravatar.cc/120?img=47",
  },

  // add as many as you want…
];

function Stars({ count }) {
  return (
    <div className="ts-stars" aria-label={`${count} out of 5 stars`}>
      {Array.from({ length: 5 }).map((_, i) => (
        <span key={i} className={i < count ? "on" : ""} aria-hidden="true">
          ★
        </span>
      ))}
    </div>
  );
}

export default function TestimonialSection() {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const [emblaRef, emblaApi] = useEmblaCarousel(
    {
      loop: true,
      align: "start",
      skipSnaps: false,
      dragFree: false,
    },
    [
      Autoplay({
        delay: 3500,
        stopOnInteraction: false,
        stopOnMouseEnter: true,
      }),
    ]
  );

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setSelectedIndex(emblaApi.selectedScrollSnap());
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
    onSelect();
    emblaApi.on("select", onSelect);
    emblaApi.on("reInit", onSelect);
  }, [emblaApi, onSelect]);

  return (
    <section className="ts-section">
      {/* Auto-scrolling banner */}
      <div className="ts-marquee" aria-hidden="true">
        <div className="ts-marquee-track">
          <span>QUALITY YOU CAN TRUST • </span>
          <span>QUALITY YOU CAN TRUST • </span>
          <span>QUALITY YOU CAN TRUST • </span>
          <span>QUALITY YOU CAN TRUST • </span>
          <span>QUALITY YOU CAN TRUST • </span>
          <span>QUALITY YOU CAN TRUST • </span>
        </div>
      </div>

      <section>
        {/* Headings */}
        <div className="ts-head">
          <p className="sub-heading">Enhancing your home experience</p>
          <h2 className="services-heading">
            Customers review <br className="br-md" />
            for expert repairs
          </h2>
        </div>

        {/* Carousel */}
        <div className="embla" ref={emblaRef}>
          <div className="embla__container">
            {TESTIMONIALS.map((t, idx) => (
              <article className="embla__slide" key={idx}>
                <div className="ts-card">
                  <Stars count={t.rating} />
                  <p className="ts-quote">{t.text}</p>
                  <div className="ts-person">
                    <img src={t.avatar} alt={`${t.name} avatar`} />
                    <div>
                      <strong className="ts-name">{t.name}</strong>
                      <div className="ts-role">{t.title}</div>
                    </div>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>

        {/* Controls */}
        <div className="ts-controls">
          <button
            className="ts-btn"
            onClick={() => emblaApi && emblaApi.scrollPrev()}
            aria-label="Previous testimonials"
          >
            ←
          </button>
          <div className="ts-dots" role="tablist" aria-label="Select testimonial slide">
            {TESTIMONIALS.map((_, i) => (
              <button
                key={i}
                role="tab"
                aria-selected={selectedIndex === i}
                className={`ts-dot ${selectedIndex === i ? "is-selected" : ""}`}
                onClick={() => emblaApi && emblaApi.scrollTo(i)}
              />
            ))}
          </div>
          <button
            className="ts-btn"
            onClick={() => emblaApi && emblaApi.scrollNext()}
            aria-label="Next testimonials"
          >
            →
          </button>
        </div>
      </section>

    </section>
  );
}
